import styled from "styled-components";

export const NewCategory = styled.div`
  background: #2786bd;
  padding: 8px 16px;
  border-radius: 40px;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  width: fit-content;
`;
